module.exports = __webpack_public_path__ + "media/cash_register.2114eb3c.mp3";